(() => {
  'use strict';
  const root = document.body.dataset.root || '/';
  const endpoint = path => `${root.endsWith('/') ? root : root + '/'}${path}`;
  let cartBusy = false;
  let searchController;
  let searchTimer;
  let variantController;
  const galleryObservers = new WeakMap();
  const announcements = new WeakMap();
  let stickyFrame = 0;
  function updateStickyPurchases() {
    document.querySelectorAll('[data-product-section]').forEach(section => {
      const button = section.querySelector('.product-add'), sticky = section.querySelector('[data-sticky-purchase]');
      if (button && sticky) sticky.hidden = button.getBoundingClientRect().bottom > 0;
    });
  }
  function scheduleStickyUpdate() {
    if (stickyFrame) return;
    stickyFrame = requestAnimationFrame(() => { stickyFrame = 0; updateStickyPurchases(); });
  }
  window.addEventListener('scroll', scheduleStickyUpdate, {passive:true});
  window.addEventListener('resize', scheduleStickyUpdate);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const status = text => { const el = document.getElementById('store-status'); if (el) el.textContent = text; };
  function errorText(error) { return typeof error?.description === 'string' ? error.description : typeof error?.message === 'string' ? error.message : document.body.dataset.error; }
  function showError(container, error) {
    const target = container?.id === 'CartContent' ? container.querySelector('.cs-cd__foot > .form-error') : container?.querySelector('.form-error');
    if (target) { target.textContent = errorText(error); target.hidden = false; }
    status(errorText(error));
  }
  function openDialog(id) {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.open) return;
    dialog.showModal();
    document.body.classList.add('modal-open');
  }
  const lightboxes = new WeakMap();
  function openProductZoom(button) {
    const gallery=button.closest('[data-gallery]');
    if(!gallery || !window.PhotoSwipeLightbox || !window.PhotoSwipe) return false;
    const buttons=[...gallery.querySelectorAll('[data-zoom]')];
    const slides=buttons.map(el=>{const img=el.closest('.source-gallery-image').querySelector('img');return {src:el.dataset.zoom,msrc:img.currentSrc||img.src,width:Number(img.getAttribute('width'))||img.naturalWidth,height:Number(img.getAttribute('height'))||img.naturalHeight,alt:img.alt,thumbnailElement:img,thumbCropped:true};});
    let box=lightboxes.get(gallery);
    if(!box){
      box=new window.PhotoSwipeLightbox({pswpModule:window.PhotoSwipe,bgOpacity:1,maxZoomLevel:3,closeTitle:gallery.dataset.closeLabel,zoomTitle:gallery.dataset.zoomLabel,errorMsg:gallery.dataset.zoomError,arrowPrev:false,arrowNext:false,counter:false,zoom:false,showHideAnimationType:reduced?'none':'zoom',closeSVG:'<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56"><circle cx="28" cy="28" r="27.5" fill="#fff" stroke="#252627" stroke-opacity=".12"/><path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/></svg>'});
      box.addFilter('thumbEl',(_,data)=>data.thumbnailElement);
      box.on('uiRegister',()=>box.pswp.ui.registerElement({name:'bottom-bar',order:5,appendTo:'wrapper',html:'<div class="pagination"><button type="button" class="pagination__item group" rel="prev"><span class="animated-arrow animated-arrow--reverse"></span></button><span class="pagination__current text-sm"><span class="pagination__current-page">1</span> / <span class="pagination__page-count"></span></span><button type="button" class="pagination__item group" rel="next"><span class="animated-arrow"></span></button></div>',onInit:(el,pswp)=>{el.querySelector('.pagination__page-count').textContent=pswp.getNumItems();const previous=el.querySelector('[rel=prev]'),next=el.querySelector('[rel=next]');previous.setAttribute('aria-label',gallery.dataset.previousLabel);next.setAttribute('aria-label',gallery.dataset.nextLabel);previous.addEventListener('click',()=>pswp.prev());next.addEventListener('click',()=>pswp.next());pswp.on('change',()=>el.querySelector('.pagination__current-page').textContent=pswp.currIndex+1);}}));
      box.on('beforeOpen',()=>document.body.classList.add('modal-open'));
      box.on('destroy',()=>{if(!document.querySelector('dialog[open]'))document.body.classList.remove('modal-open');});
      box.init();lightboxes.set(gallery,box);
    }
    box.loadAndOpen(buttons.indexOf(button),slides);return true;
  }
  function initDialog(dialog) {
    if (dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.body.classList.remove('modal-open');
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
  }
  function renderCart(html) {
    const doc = new DOMParser().parseFromString(html || '', 'text/html');
    const content = doc.getElementById('CartContent');
    const current = document.getElementById('CartContent');
    if (!content || !current) throw new Error(document.body.dataset.error);
    const active = document.activeElement;
    const previousKey = active?.dataset.cartChange;
    const previousLabel = active?.getAttribute('aria-label');
    const previousScroll = current.querySelector('.cs-cd__body')?.scrollTop || 0;
    current.replaceWith(content);
    const count = Number(content.dataset.cartTotalCount || 0);
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; el.hidden = count === 0; });
    content.querySelector('.cs-cd__body').scrollTop = previousScroll;
    if (document.getElementById('cart-dialog').open) {
      const restore = [...content.querySelectorAll('[data-cart-change]')].find(el => el.dataset.cartChange === previousKey && el.getAttribute('aria-label') === previousLabel);
      (restore || content.querySelector('[data-close-dialog]'))?.focus({preventScroll:true});
    }
    document.dispatchEvent(new CustomEvent('cart:updated', {detail:{itemCount:count}}));
  }
  async function refreshCart() {
    const response = await fetch(endpoint('?sections=cart-drawer'), {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error(document.body.dataset.error);
    const sections = await response.json();
    renderCart(sections['cart-drawer']);
  }
  async function mutateCart(path, body, container) {
    if (cartBusy) return;
    cartBusy = true;
    const drawer = document.getElementById('cart-dialog');
    drawer?.setAttribute('aria-busy', 'true');
    const controls = [...document.querySelectorAll('[data-product-form] button[type=submit], [data-cart-change], .cs-cd__go')];
    const enabled = controls.filter(el => !el.disabled);
    enabled.forEach(el => el.disabled = true);
    container?.querySelectorAll('.form-error').forEach(el => el.hidden = true);
    let accepted = false;
    try {
      let response;
      if (body instanceof FormData) {
        body.set('sections', 'cart-drawer');
        body.set('sections_url', location.pathname);
        response = await fetch(endpoint(path), {method:'POST', headers:{Accept:'application/json'}, body});
      } else {
        response = await fetch(endpoint(path), {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({...body, sections:['cart-drawer'], sections_url:location.pathname})});
      }
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw data;
      accepted = true;
      if (document.body.dataset.cartDrawer !== 'true') { location.assign(document.body.dataset.cartUrl || endpoint('cart')); return; }
      try { renderCart(data.sections?.['cart-drawer']); } catch { await refreshCart(); }
      openDialog('cart-dialog');
    } catch (error) {
      // A successful mutation must never be repeated if only rendering failed.
      if (accepted) location.assign(document.body.dataset.cartUrl || endpoint('cart'));
      else showError(container, error);
    } finally {
      cartBusy = false;
      drawer?.removeAttribute('aria-busy');
      enabled.filter(el => el.isConnected).forEach(el => el.disabled = false);
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    if (!form.reportValidity()) return;
    const id = form.querySelector('[name=id]');
    if (!id?.value || id.disabled) return;
    mutateCart('cart/add.js', new FormData(form), form);
  });
  document.addEventListener('click', async event => {
    const close = event.target.closest('[data-close-dialog]');
    if (close) { close.closest('dialog')?.close(); return; }
    const open = event.target.closest('[data-open-dialog]');
    if (open) { event.preventDefault(); openDialog(open.dataset.openDialog); return; }
    const cart = event.target.closest('[data-cart-open]');
    if (cart && document.body.dataset.cartDrawer === 'true') {
      event.preventDefault();
      try { await refreshCart(); openDialog('cart-dialog'); } catch { location.assign(cart.href); }
      return;
    }
    const change = event.target.closest('[data-cart-change]');
    if (change) { event.preventDefault(); await mutateCart('cart/change.js', {id:change.dataset.cartChange,quantity:Number(change.dataset.quantity)}, document.getElementById('CartContent')); return; }
    const zoom = event.target.closest('[data-zoom]');
    if (zoom) {
      if(openProductZoom(zoom))return;
      const image = document.getElementById('zoom-image');
      image.src = zoom.dataset.zoom;
      image.alt = zoom.closest('.source-gallery-image')?.querySelector('img')?.alt || '';
      openDialog('image-dialog'); return;
    }
    const galleryImage=event.target.closest('[data-gallery-advance]');
    if(galleryImage && matchMedia('(pointer:fine)').matches){const track=galleryImage.closest('[data-gallery-track]'),slide=galleryImage.closest('.product-gallery__media'),rect=galleryImage.getBoundingClientRect();const next=[...track.children].indexOf(slide)+(event.clientX>rect.left+rect.width/2?1:-1),target=track.children[Math.max(0,Math.min(track.children.length-1,next))];track.scrollTo({left:target.offsetLeft-track.children[0].offsetLeft,behavior:reduced?'instant':'smooth'});return;}
    const thumb = event.target.closest('[data-gallery-index]');
    if (thumb) {
      const track = thumb.closest('[data-gallery]').querySelector('[data-gallery-track]');
      track.scrollTo({left: Number(thumb.dataset.galleryIndex) * track.clientWidth, behavior:reduced?'instant':'smooth'});return;
    }
    const faq = event.target.closest('[data-faq-toggle]');
    if (faq) {const target=document.getElementById(faq.getAttribute('aria-controls'));const open=faq.getAttribute('aria-expanded')!=='true';faq.setAttribute('aria-expanded',String(open));target?.classList.toggle('is-open',open);return;}
    const bmsArrow=event.target.closest('[data-bms-prev],[data-bms-next]');
    if(bmsArrow){const bms=bmsArrow.closest('[data-bms]');const cards=[...bms.querySelectorAll('[data-bms-card]')];const pages=Math.ceil(cards.length/3);const page=(Number(bms.dataset.page||0)+(bmsArrow.hasAttribute('data-bms-prev')?-1:1)+pages)%pages;bms.dataset.page=page;cards.forEach((card,i)=>card.hidden=Math.floor(i/3)!==page);return;}
    const arrow = event.target.closest('[data-rail-prev],[data-rail-next]');
    if (arrow) { const owner=arrow.closest('.product-rail,.product-rail-source');if(!owner)return;const rail=owner.querySelector('[data-rail]'); rail.scrollBy({left:rail.clientWidth * (arrow.hasAttribute('data-rail-prev')?-1:1),behavior:reduced?'instant':'smooth'}); }
  });
  document.addEventListener('change', async event => {
    if (event.target.matches('[data-auto-submit]')) event.target.form.requestSubmit();
    if (!event.target.matches('[data-variant-option]')) return;
    const section = event.target.closest('[data-product-section]');
    const values = [...section.querySelectorAll('[data-variant-option]')].filter(el => el.tagName === 'SELECT' || el.checked).map(el => el.value);
    const position = event.target.dataset.optionPosition;
    const qty = section.querySelector('[name=quantity]')?.value;
    const plan = section.querySelector('[name=selling_plan]')?.value;
    const focused = document.activeElement === event.target;
    variantController?.abort();
    const controller = new AbortController(); variantController = controller;
    const url = new URL(section.dataset.productUrl, location.origin);
    url.searchParams.set('option_values', values.join(','));
    url.searchParams.set('section_id', section.dataset.productSection);
    section.setAttribute('aria-busy','true');
    section.querySelectorAll('.product-add,.sticky-purchase button').forEach(el => el.disabled = true);
    try {
      const response = await fetch(url, {signal:controller.signal});
      if (!response.ok) throw new Error(document.body.dataset.error);
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const next = doc.querySelector('[data-product-section]');
      if (!next) throw new Error(document.body.dataset.error);
      section.replaceWith(next);
      if (qty && next.querySelector('[name=quantity]')) next.querySelector('[name=quantity]').value = qty;
      if (plan && next.querySelector(`[name=selling_plan] option[value="${CSS.escape(plan)}"]`)) next.querySelector('[name=selling_plan]').value = plan;
      init(next);
      const id = next.querySelector('[name=id]')?.value;
      const permalink = new URL(location.href);permalink.searchParams.delete('option_values');
      if (id) permalink.searchParams.set('variant',id);else permalink.searchParams.delete('variant');
      history.replaceState({},'',permalink);
      if (focused) next.querySelector(`[data-option-position="${position}"]:checked,select[data-option-position="${position}"]`)?.focus({preventScroll:true});
    } catch (error) {
      if (error.name === 'AbortError') return;
      // Reload the selected option combination so the server remains the source of truth.
      url.searchParams.delete('section_id'); location.assign(url);
    } finally { if (section.isConnected && !controller.signal.aborted) section.removeAttribute('aria-busy'); }
  });
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-predictive-input]')) return;
    clearTimeout(searchTimer);searchController?.abort();
    const input = event.target;
    const results = input.form.querySelector('[data-predictive-results]');
    const q = input.value.trim();
    if (q.length < 2) { results.replaceChildren();return; }
    searchTimer = setTimeout(async () => {
      const controller = new AbortController();searchController = controller;
      const url = new URL(endpoint('search/suggest'),location.origin);
      url.searchParams.set('q',q);url.searchParams.set('resources[type]','product');url.searchParams.set('resources[limit]','5');url.searchParams.set('section_id','predictive-search');
      try {
        const response = await fetch(url,{signal:controller.signal});
        if (!response.ok) return;
        const html = await response.text();
        if (!controller.signal.aborted && input.value.trim() === q) results.innerHTML = html;
      } catch (error) { if (error.name !== 'AbortError') results.replaceChildren(); }
    },250);
  });
  function initBundle(root) {
    if(root.dataset.ready)return;root.dataset.ready='true';
    const sizes=[...root.querySelectorAll('[data-bb-size-btn]')],categories=[...root.querySelectorAll('[data-bb-cat-btn]')],cards=[...root.querySelectorAll('[data-bb-card]')],complete=root.querySelector('[data-bb-complete]');
    let max=0;const selected=new Set();
    const refresh=()=>{
      root.querySelector('[data-bb-count]').textContent=root.dataset.countLabel.replace('[count]',selected.size).replace('[max]',max);
      complete.disabled=selected.size!==max||max===0;
      cards.forEach(card=>{const button=card.querySelector('[data-bb-add-btn]'),active=selected.has(card);button.classList.toggle('is-selected',active);button.setAttribute('aria-pressed',String(active));if(button.dataset.available==='true')button.textContent=active?root.dataset.addedLabel:root.dataset.addLabel;button.disabled=button.dataset.available!=='true'||(!active&&selected.size>=max);});
    };
    sizes.forEach(button=>button.addEventListener('click',()=>{
      sizes.forEach(b=>{b.classList.toggle('is-active',b===button);b.setAttribute('aria-pressed',String(b===button));});max=Number(button.dataset.count);while(selected.size>max)selected.delete([...selected].pop());
      const description=root.querySelector('[data-bb-box-description]');description.textContent=button.dataset.description||'';description.hidden=!description.textContent;refresh();
    }));
    categories.forEach(button=>button.addEventListener('click',()=>{categories.forEach(b=>{b.classList.toggle('is-active',b===button);b.setAttribute('aria-pressed',String(b===button));});cards.forEach(card=>card.hidden=card.dataset.category!==button.dataset.category);}));
    cards.forEach(card=>card.querySelector('[data-bb-add-btn]').addEventListener('click',()=>{if(selected.has(card))selected.delete(card);else if(selected.size<max)selected.add(card);refresh();}));
    complete.addEventListener('click',async()=>{
      if(complete.disabled||cartBusy)return;
      const totals=new Map();for(const card of selected){const id=card.querySelector('[data-bb-variant-select]')?.value||card.querySelector('[data-bb-add-btn]').dataset.variantId;if(!id)return;totals.set(id,(totals.get(id)||0)+1);}
      const buttons=[...root.querySelectorAll('button,select')].filter(el=>!el.disabled);buttons.forEach(el=>el.disabled=true);
      await mutateCart('cart/add.js',{items:[...totals].map(([id,quantity])=>({id,quantity}))},root);
      buttons.forEach(el=>el.disabled=false);refresh();
    });
    sizes[0]?.click();categories[0]?.click();
  }

  function init(scope=document) {
    scope.querySelectorAll('.nav-dropdown').forEach(dropdown=>{if(dropdown.dataset.ready)return;dropdown.dataset.ready='true';dropdown.addEventListener('pointerenter',()=>{if(matchMedia('(hover:hover)').matches)dropdown.open=true;});dropdown.querySelector('summary')?.addEventListener('click',e=>{if(dropdown.open&&matchMedia('(hover:hover)').matches&&dropdown.matches(':hover'))e.preventDefault();});dropdown.addEventListener('pointerleave',()=>{if(!dropdown.contains(document.activeElement))dropdown.open=false;});dropdown.addEventListener('focusout',()=>queueMicrotask(()=>{if(!dropdown.contains(document.activeElement))dropdown.open=false;}));});
    scope.querySelectorAll("[data-box-builder]").forEach(initBundle);
    scope.querySelectorAll('dialog').forEach(initDialog);
    scope.querySelectorAll('[data-gallery]').forEach(gallery => {
      if (galleryObservers.has(gallery)) return;
      const track = gallery.querySelector('[data-gallery-track]');
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (!entry.isIntersecting) return;
          const index = [...track.children].indexOf(entry.target);
          gallery.querySelectorAll('[data-gallery-index]').forEach(el => {
            if (Number(el.dataset.galleryIndex) === index) el.setAttribute('aria-current','true');else el.removeAttribute('aria-current');
          });
        });
      },{root:track,threshold:.6});
      [...track.children].forEach(el => observer.observe(el));galleryObservers.set(gallery,observer);
      const selected = gallery.closest('[data-product-section]')?.dataset.selectedMedia;
      const slide = [...track.children].find(el => el.dataset.mediaId === selected);
      if (slide) track.scrollLeft = [...track.children].indexOf(slide) * track.clientWidth;
    });
    scope.querySelectorAll('[data-bms]').forEach(bms=>{if(bms.dataset.ready)return;bms.dataset.ready='true';[...bms.querySelectorAll('[data-bms-card]')].forEach((card,i)=>card.hidden=i>=3);});
    scope.querySelectorAll('.native-reviews').forEach(el=>{if(el.swiper||!window.Swiper)return;const section=el.closest('.testimonials-source');new window.Swiper(el,{speed:300,spaceBetween:20,loop:true,centeredSlides:true,navigation:{nextEl:section.querySelector('[data-rail-next]'),prevEl:section.querySelector('[data-rail-prev]')},pagination:{el:section.querySelector('[class^=testimonials-pagination]'),clickable:true},breakpoints:{320:{slidesPerView:1.3,spaceBetween:20},768:{slidesPerView:2,spaceBetween:20},1024:{slidesPerView:4.5,spaceBetween:28}}});});
    scheduleStickyUpdate();
    scope.querySelectorAll('[data-announcement]').forEach(el => {
      if (announcements.has(el) || reduced) return;
      const slides = [...el.querySelectorAll('.announcement-slide')];
      if (slides.length < 2) return;
      let index = 0;
      announcements.set(el,setInterval(() => {
        if (!el.isConnected) {clearInterval(announcements.get(el));return;}
        if (document.hidden || el.matches(':hover') || el.contains(document.activeElement)) return;
        slides[index].hidden = true; index = (index+1)%slides.length;slides[index].hidden = false;
      },6500));
    });
    scope.querySelectorAll('.nav-dropdown').forEach(el => {
      if (el.dataset.hoverReady) return;el.dataset.hoverReady='true';
      el.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')el.open=true;});
      el.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'&&!el.contains(document.activeElement))el.open=false;});
    });
    scope.querySelectorAll('[data-countdown]').forEach(el => {
      if (el.dataset.ready) return;el.dataset.ready='true';
      const end = Date.parse(el.dataset.countdown);
      if (!Number.isFinite(end)) return;
      const update=()=>{const s=Math.max(0,Math.floor((end-Date.now())/1000));el.hidden=s===0;el.textContent=[Math.floor(s/3600),Math.floor(s%3600/60),s%60].map(n=>String(n).padStart(2,'0')).join(' : ');return s;};
      if (update()) {const timer=setInterval(()=>{if(!el.isConnected||!update())clearInterval(timer);},1000);}
    });
  }
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:block:select',event=>{const slide=event.target.closest('.announcement-slide');if(slide){slide.parentElement.querySelectorAll('.announcement-slide').forEach(el=>el.hidden=el!==slide);}});
  window.addEventListener('pageshow',event=>{if(event.persisted)refreshCart().catch(()=>{});});
  init();
})();
